import React, { useState, useEffect } from "react";
import axios from "axios";
import { environment } from "../../../environment.js";
import { Button, FormControl, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Dropdown } from "react-bootstrap";
import Loader from "../../Components/Loader.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Login from "../Login.js";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Select from "react-select";
import NavbarNew from "../../Components/NavbarNew.js";
import CsvDownload from "react-json-to-csv";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const ListPartnerDevices = ({ history }) => {
  const [dap_devices, setDevices] = useState([]);
  const [dap_customers, setDapCustomers] = useState([]);
  const [defaultProfileDetails, setDefaultProfileId] = useState("");
  const [customer_name, setCustomerName] = useState("");
  const [cust_name, setCustomer] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deviceData, setDeviceData] = useState([]);
  const [show1, setshow] = useState(false);
  const handleshow = () => setshow(true);
  const handleclose = () => {
    setshow(false);
  };
  const [selectedLabel, setLabel] = useState("");
  const [searchLoading, setSearchLoading] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [convertCsv, setConvertCsv] = useState(false);
  const [startTs, setStartTs] = useState();
  const [endTs, setEndTs] = useState();
  let userDetails = {};
  const [iaqData, setIaqData] = useState([]);
  const [CO2spikeData, setCO2SpikeData] = useState([]);
  const [PM25spikeData, setPM25SpikeData] = useState([]);
  const [PM10spikeData, setPM10SpikeData] = useState([]);
  const [TEMPspikeData, setTEMPSpikeData] = useState([]);
  const [TVOCspikeData, setTVOCSpikeData] = useState([]);

  let deviceDataArray = [];

  let iaqDataArray = [];

  let CO2spikeDataArray = [];

  let PM25spikeDataArray = [];

  let PM10spikeDataArray = [];

  let TVOCspikeDataArray = [];

  let TEMPspikeDataArray = [];

  const headers = [
    { label: "ts", key: "TIMESTAMP" },
    { label: "time", key: "TIME" },
    { label: "iaq value", key: "IAQ" },
    { label: "co2 value", key: "CO2[PPM]" },
    { label: "pm2.5 value", key: "PM2.5[micrograms/m3]" },
    { label: "pm 10 value", key: "PM10[micrograms/m3]" },
    { label: "tvoc value", key: "TVOC[PPB]" },
    { label: "temp value", key: "TEMPERATURE[celsius]" },
    { label: "rh value", key: "HUMIDITY[percentage]" },
    { label: "lat", key: "LAT" },
    { label: "lon", key: "LON" },
    { label: "device", key: "device" },
  ];

  const spike_headers = [
    { label: "ts", key: "TIMESTAMP" },
    { label: "time", key: "TIME" },
    { label: "iaq value", key: "IAQ" },
    { label: "co2 value", key: "CO2_ppm" },
    { label: "pm2.5 value", key: "PM25_ppm" },
    { label: "pm 10 value", key: "PM10_ppm" },
    { label: "tvoc value", key: "TVOC_ppb" },
    { label: "temp value", key: "TEMPERATURE_Celsius" },
    { label: "rh value", key: "HUMIDITY_rh" },
    { label: "device", key: "device" },
  ];

  const handleClose = () => setShow(false);
  const handleShow = (device) => {
    setDeviceData(device);
    console.log(device);
    setShow(true);
  };
  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = (deviceid, devicename) => {
    console.log(devicename);
    setDeviceData(devicename);
    setShowModal(true);
  };
  const getDefaultProfileName = async (id) => {
    await axios
      .post(
        environment.dap_url + `external_api/getDefaultProfileName`,
        { tenant_id: id },
        {
          headers: {
            "X-Authorization": "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        console.log(res.data.profileId);
        setDefaultProfileId(res.data.profileId);
      })
      .catch(function (error) {
        console.log(error);
        window.alert("something wrong Happened");
      });
  };

  const getAllTenantdevices = async () => {
    let userDetails = localStorage.getItem("userDetails");
    let user = JSON.parse(localStorage.getItem("user"));
    userDetails = JSON.parse(userDetails);
    await axios
      .get(environment.dap_url + `dapDevice/getDevicesByPartnerId/` + user._id)

      .then((res) => {
        console.log(res.data);
        setDevices(res.data.reverse());
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const historicaData = (_id) => {
    console.log("asdrfyhuijkoljhgfdszdfghj");
    const findLabel = dap_devices.find((item) => item._id === _id);
    let label = findLabel.deviceLabel;
    setLabel(findLabel.deviceLabel);
    console.log(findLabel);
    handleshow();
  };

  useEffect(() => {
    let tenantDetails = JSON.parse(localStorage.getItem("tenantDetails"));
    getDefaultProfileName(tenantDetails.data.id.id);
    getAllTenantdevices();
    let userDetails = localStorage.getItem("userDetails");
    userDetails = JSON.parse(userDetails);
    console.log(userDetails.data.id.id);

    let sd = new Date().toISOString().split("T")[0];
    // sd.setUTCHours(0, 0, 0, 0)
    setStartTs(sd);

    let ed = new Date().toISOString().split("T")[0];
    setEndTs(ed);
    // axios
    //   .get(environment.apiUrl + `customers?pageSize=1000&page=0`, {
    //     headers: {
    //       "X-Authorization": "Bearer " + localStorage.getItem("token"),
    //     },
    //   })

    //   .then((res) => {
    //     console.log(res.data.data);
    //     setDapCustomers(res.data.data);
    //   })
    //   .catch(function (error) {
    //     window.alert(error.message);
    //   });
  }, []);

  const changeFromDate = (e) => {
    console.log(e.target.value);
    setStartTs(e.target.value);
  };
  const changeToDate = (e) => {
    console.log(e.target.value);
    setEndTs(e.target.value);
  };
  const csvReport = {
    data: iaqData,
    headers: headers,
    filename: selectedLabel + ".csv",
  };
  const searchData = () => {
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let id = userDetails.data.id.id;
    console.log(id);
    let tenantId = userDetails.data.tenantId.id;
    //let label = selectedDevice
    if (new Date(startTs) > new Date(endTs)) {
      alert("End date can't be less than the start date");
    }
    let startDate = new Date(startTs).toISOString();
    let endDate = "";
    let currentDate = new Date(Date.now()).toISOString().split("T")[0];
    if (currentDate == endTs) {
      let eDate = new Date(endTs);
      let curr_h = new Date().getHours();
      let curr_m = new Date().getMinutes();
      let curr_s = new Date().getSeconds();
      eDate.setUTCHours(curr_h, curr_m, curr_s, 0);
      endDate = eDate.toISOString();
    } else {
      let eDate = new Date(endTs);
      eDate.setUTCHours(23, 59, 59, 0);
      endDate = eDate.toISOString();
    }
    console.log({ id, tenantId, startDate, endDate });
    setSearchLoading(true);
    setConvertCsv(true);
    let searchURL =
      environment.dap_url +
      "external_api/partner/" +
      id +
      "/device/" +
      selectedLabel +
      "/download";

    axios
      .post(searchURL, { tenant_id: tenantId, start: startDate, end: endDate })
      .then((res) => {
        setSearchLoading(false);
        setConvertCsv(false);
        setShowDownload(true);
        console.log(res.status);
        if (res.data.iaq.length == 0) {
          alert("no data found");
          setShowDownload(false);
          return;
        }

        res.data.iaq.forEach((element) => {
          //iaqDataArray.push({ ts: element.ts, iaq_value: element.value });

          let date = new Date(element.ts);
          console.log("date and time in your timezone", date.toISOString());
          let dateArr = date.toISOString().split("T");
          let d = dateArr[0].split("-");
          let t = dateArr[1].split(".")[0];
          let iaqtime = d[2] + "/" + d[1] + "/" + d[0] + " " + t;
          iaqDataArray.push({
            TIMESTAMP: element.ts,
            DATE_TIME: iaqtime,
            IAQ: element.value,
          });
          //spikeDataArray.push({ TIMESTAMP: element.ts, TIME: iaqtime });
        });
        console.log(res.data.co2);

        res.data.co2.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item["CO2[PPM]"] = element.value;
            }
          });

          if (element.value == 0 || element.value > 1000) {
            console.log(new Date(element.ts).getTime());
            let dateCo2 = new Date(element.ts);
            let dateArrCo2 = dateCo2.toISOString();
            let dCo2 = dateArrCo2[0].split("-");
            let tCo2 = dateArrCo2[1].split(".")[0];
            let co2time = dCo2[2] + "/" + dCo2[1] + "/" + dCo2[0] + " " + tCo2;
            CO2spikeDataArray.push({
              DATE_TIME: co2time,
              CO2_ppm: element.value,
            });
          }
        });

        res.data.pm25.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item["PM2.5[micrograms/m3]"] = element.value;
            }
          });
          if (element.value > 200) {
            let datePM25 = new Date(element.ts);
            let dateArrPM25 = datePM25.toISOString();
            let dPM25 = dateArrPM25[0].split("-");
            let tPM25 = dateArrPM25[1].split(".")[0];
            let pm25time =
              dPM25[2] + "/" + dPM25[1] + "/" + dPM25[0] + " " + tPM25;
            PM25spikeDataArray.push({
              DATE_TIME: pm25time,
              PM_2_5_ppm: element.value,
            });
          }
        });
        res.data.pm10.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item["PM10[micrograms/m3]"] = element.value;
            }
          });

          if (element.value > 200) {
            let datePM10 = new Date(element.ts);
            let dateArrPM10 = datePM10.toISOString();
            let dPM10 = dateArrPM10[0].split("-");
            let tPM10 = dateArrPM10[1].split(".")[0];
            let pm10time =
              dPM10[2] + "/" + dPM10[1] + "/" + dPM10[0] + " " + tPM10;
            PM10spikeDataArray.push({
              DATE_TIME: pm10time,
              PM_10_ppm: element.value,
            });
          }
        });
        res.data.temp.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item["TEMPERATURE[celsius]"] = element.value;
            }
          });

          if (element.value > 50) {
            let dateTemp = new Date(element.ts);
            let dateArrTemp = dateTemp.toISOString();
            let dTemp = dateArrTemp[0].split("-");
            let tTemp = dateArrTemp[1].split(".")[0];
            let temptime =
              dTemp[2] + "/" + dTemp[1] + "/" + dTemp[0] + " " + tTemp;
            TEMPspikeDataArray.push({
              DATE_TIME: temptime,
              TEMP: element.value,
            });
          }
        });

        res.data.rh.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item["HUMIDITY[percentage]"] = element.value;
            }
          });
        });

        res.data.tvoc.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item["TVOC[PPB]"] = element.value;
            }
          });
          if (element.value > 10) {
            let dateTVOC = new Date(element.ts);
            let dateArrTVOC = dateTVOC.toISOString();
            let dTVOC = dateArrTVOC[0].split("-");
            let tTVOC = dateArrTVOC[1].split(".")[0];
            let tvoctime =
              dTVOC[2] + "/" + dTVOC[1] + "/" + dTVOC[0] + " " + tTVOC;
            TVOCspikeDataArray.push({
              DATE_TIME: tvoctime,
              TVOC_ppm: element.value,
            });
          }
        });

        res.data.device.forEach((element) => {
          iaqDataArray.forEach((item) => {
            if (item.TIMESTAMP == element.ts) {
              item.device = element.device_label;
            }
          });
          if (element.value > 10) {
            let dateDevice = new Date(element.ts);
            let dateArrDevice = dateDevice.toISOString();
            let dDevice = dateArrDevice[0].split("-");
            let tDevice = dateArrDevice[1].split(".")[0];
            let devicetime =
              dDevice[2] + "/" + dDevice[1] + "/" + dDevice[0] + " " + tDevice;
            deviceDataArray.push({
              DATE_TIME: devicetime,
              device: element.value,
            });
          }
        });

        console.log(iaqDataArray);
        console.log(CO2spikeDataArray);
        setIaqData(iaqDataArray);
        setCO2SpikeData(CO2spikeDataArray);
        setTEMPSpikeData(TEMPspikeDataArray);
        setPM25SpikeData(PM25spikeDataArray);
        setPM10SpikeData(PM10spikeDataArray);
        setTEMPSpikeData(TEMPspikeDataArray);
        setTVOCSpikeData(TVOCspikeDataArray);
      })
      .catch((error) => {
        console.log(error.statusCode);
        setShowDownload(false);
      });
  };

  const submitHandler = async (customer_details) => {
    let responsedata;
    //console.log(deviceData, device, deviceName, deviceLabel);
    // console.log(deviceData);
    // console.log(defaultProfileDetails);
    // console.log(customerName);
    // setCustomerName(customerName);
    await axios
      .post(
        environment.apiUrl + "device",
        {
          name: deviceData.deviceName,
          label: deviceData.deviceLabel,
          deviceProfileId: {
            entityType: "DEVICE_PROFILE",
            // id: "4bf465c0-e922-11eb-aeab-6338f3fa1c68",
            id: defaultProfileDetails,
          },
          additionalInfo: {
            gateway: false,
            overwriteActivityTime: false,
            description: deviceData.description,
          },
          // customerId: null,
          // transportType: dap_transport_type,
          type: "DEFAULT",
        },
        {
          headers: {
            "X-Authorization": "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        console.log(res);
        console.log(deviceData);
        assignDevice(customer_details.value, deviceData, res.data);
      })
      .catch((err) => {
        console.log(err, "qwerty");
        console.log(err.status, "qwerty");
        console.log(err.response.data.message, "qwerty");

        // MySwal.fire({
        //   title: <p>{err?.response?.data?.message}</p>,
        //   type: "error",
        // });

        if (
          err?.response?.data?.message ===
          "Device with such name already exists!"
        ) {
          assignDeviceToOtherUser(customer_details.value, deviceData);
        } else {
          MySwal.fire({
            title: <p>{err.response.data.message}</p>,
            type: "error",
          });
        }
      });
  };

  const assignDeviceToOtherUser = async (customer, tbDeviceData) => {
    console.log(customer, tbDeviceData);
    await axios
      .post(
        // https://core-ce.diaq.in/api/customer/fac8ab30-2fd4-11ec-803e-45aeaa5f3440/device/34743ae0-51ac-11ec-82d8-1997fbc31aed
        environment.apiUrl +
          "customer/" +
          customer.id +
          "/device/" +
          tbDeviceData.deviceId,
        {},
        {
          headers: {
            "X-Authorization": "Bearer " + localStorage.getItem("token"),
          },
        }
      )

      .then((res) => {
        axios
          .put(environment.dap_url + "updateWithObjId/" + tbDeviceData._id, {
            deviceOwnerId: customer.id,
          })
          .then((res) => {
            console.log(res);
            getAllTenantdevices();
            MySwal.fire({
              title: <p>Device assigned successfully</p>,
              type: "success",
            });
            setShowModal(false);
          })
          .catch((err) => {
            console.log(err);
            MySwal.fire({
              title: <p>{err?.response?.data?.message}</p>,
              type: "error",
            });
          });
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: <p>{err?.response?.data?.message}</p>,
          type: "error",
        });
      });
  };
  const updatedeviceinMongo = async (
    res,
    c_id,
    deviceData,
    tbDeviceData,
    deviceUserDetails
  ) => {
    await axios
      .put(environment.dap_url + "assignToCustomer/" + deviceData._id, {
        deviceId: tbDeviceData.id.id,
        deviceProfileId: tbDeviceData.deviceProfileId.id,
        tenantId: deviceData.tenantId,
        deviceProfileName: deviceData.deviceProfileName,
        deviceOwnerId: deviceUserDetails.customerId.id,
        accessToken: res.data.credentialsId,
      })
      .then((res) => {
        getAllTenantdevices();
        console.log(res.data.data);
        MySwal.fire({
          title: <p>Device has been assigned successfully</p>,
          type: "success",
        });
      })
      .catch((err) => {
        console.log(err, "zxcvbnm");
        MySwal.fire({
          title: <p>Failed to assign device.</p>,
          type: "error",
        });
      });
  };
  const fetchAccessToken = async (
    c_id,
    deviceData,
    tbDeviceData,
    deviceUserDetails
  ) => {
    await axios
      .get(
        environment.apiUrl + `device/` + tbDeviceData.id.id + `/credentials`,
        {
          headers: {
            "X-Authorization": "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        console.log(res);
        updatedeviceinMongo(
          res,
          c_id,
          deviceData,
          tbDeviceData,
          deviceUserDetails
        );
      })
      .catch(function (error) {
        console.log(error);
        //window.alert("something wrong Happened");
      });
  };
  const assignDevice = (c_id, deviceData, tbDeviceData) => {
    console.log(tbDeviceData.id.id);

    //  in this function after creation of device in tb we will assign it to customer user it selected then we will fetch its accesstoken in credentials api call then we will update the details in mongo
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        axios
          .post(
            // https://core-ce.diaq.in/api/customer/fac8ab30-2fd4-11ec-803e-45aeaa5f3440/device/34743ae0-51ac-11ec-82d8-1997fbc31aed
            environment.apiUrl +
              "customer/" +
              c_id.id +
              "/device/" +
              tbDeviceData.id.id,
            {},
            {
              headers: {
                "X-Authorization": "Bearer " + localStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            console.log(res.data.data);
            let deviceUserDetails = res.data;
            fetchAccessToken(c_id, deviceData, tbDeviceData, deviceUserDetails);
            setShowModal(false);
          })
          .catch((err) => {
            MySwal.fire({
              title: (
                <p>
                  {err?.response?.data?.message ||
                    "Device couldn't be assigned"}
                </p>
              ),
              type: "error",
            });
          });

        console.log(deviceData);
        console.log("customer", c_id.id);
        console.log("device", deviceData);
      }
    });
  };

  const updateDeviceLocation = (deviceId) => {
    history.push(`/update-device-location/${deviceId}`);
    console.log(deviceId);
  };

  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
    },
    {
      dataField: "deviceLabel",
      text: "Label",
      sort: true,
    },
    {
      dataField: "deviceType",
      text: "Category",
      sort: true,
    },
    {
      dataField: `customerDetails[0].organization`,
      text: "Organisation",
      sort: true,
    },
    {
      dataField: `customerDetails[0].userFirstName`,
      text: "Assigned Customer",
      sort: true,
    },
    {
      dataField: `customerDetails[0].city`,
      text: "Location",
      sort: true,
    },
    {
      dataField: "industry",
      text: "Industry",
      sort: true,
    },

    {
      dataField: "deviceAlias",
      text: "Installed Place",
      sort: true,
    },

    {
      dataField: `_id`,
      text: "Action",
      sort: true,
      formatter: (dataField) => {
        return (
          <div>
            <LinkContainer to={"/device-details/" + dataField}>
              <Button variant="light" className="btn-sm">
                View Details
              </Button>
            </LinkContainer>
            <Button
              variant="primary"
              className="btn-sm"
              onClick={() => historicaData(dataField)}
            >
              Historical Data
            </Button>
          </div>
        );
      },
    },
  ];

  const changeNameHandler = (
    deviceName,
    deviceId,
    _id,
    deviceLabel,
    customerId,
    tenantId,
    profileId
  ) => {
    console.log(deviceName, deviceId, _id);
    axios
      .post(
        // https://core.diaq.hhgs.in/api/device
        environment.apiUrl + "device",
        {
          id: {
            entityType: "DEVICE",
            id: deviceId,
          },

          tenantId: {
            entityType: "TENANT",
            id: tenantId,
          },
          customerId: {
            entityType: "CUSTOMER",
            id: customerId,
          },
          name: deviceName,
          type: "default",
          label: deviceLabel,
          deviceProfileId: {
            entityType: "DEVICE_PROFILE",
            id: profileId,
          },
        },
        {
          headers: {
            "X-Authorization": "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        console.log(res);
        updateDeviceInDB(_id, deviceName);
        //update device name in database
      })
      .catch((err) => {
        MySwal.fire({
          title: <p>{err?.response?.data?.message || "Operation failed"}</p>,
          type: "error",
        });
      });
  };

  const updateDeviceInDB = (id, deviceName) => {
    console.log(id, deviceName);
    axios
      .put(environment.dap_url + "deviceApi/updateDeviceName", {
        deviceId: id,
        deviceName: deviceName,
      })
      .then((res) => {
        MySwal.fire({
          title: <p>Device name saved!</p>,
          type: "success",
        });
        handleClose();
        getAllTenantdevices();
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: <p>{err?.response?.data?.message || "Operation failed"}</p>,
          type: "error",
        });
      });
  };

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ];

  return (
    <>
      <div className="container-fluid">
        <NavbarNew />

        <h4 className="card-title">DEVICES</h4>
        <div className="row">
          <LinkContainer
            to={"assigncustomer/"}
            style={{
              float: "right",
              marginLeft: 1064,
            }}
          >
            <Button variant="light" className="btn-sm my-3">
              Assign Customer
            </Button>
          </LinkContainer>
          <div className="col-12">
            <ToolkitProvider
              keyField="id"
              bootstrap4
              data={dap_devices}
              columns={columns}
              search
            >
              {(props) => (
                <div>
                  <div className="d-flex align-items-center">
                    <p className="mb-2 mr-2">Search in table:</p>
                    <SearchBar {...props.searchProps} />
                  </div>
                  <BootstrapTable
                    defaultSorted={defaultSorted}
                    pagination={paginationFactory()}
                    {...props.baseProps}
                    wrapperClasses="table-responsive"
                  />
                </div>
              )}
            </ToolkitProvider>
          </div>
        </div>
      </div>

      <Modal
        show={show1}
        onHide={handleclose}
        keyboard={false}
        backdrop="static"
       
         style={{ 
         width:1100}}
         
                
      >
        <Modal.Header closeButton  style={{ 
         marginRight:270}}>
          <Modal.Title>Historical Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* {selectedLabel} */}

          <FormControl
            type="text"
            value={selectedLabel}
            disabled
            placeholder="Device Label"
            style={{ fontSize: "14px", width: "150px" }}
          />

          <div className="row" style={{ paddingTop: "15px",width:700}}>
            <div className="col-md-6">
              <h5> From Date</h5>
              <span>(mm-dd-yyyy)</span>
              <input
                type="date"
                className="form-control"
                name="start-date"
                value={startTs}
                onChange={(e) => changeFromDate(e)}
              />
            </div>
            <div className="col-md-6" style={{width:700}}>
              <h5> To Date</h5>
              <span>(mm-dd-yyyy)</span>
              <input
                type="date"
                className="form-control"
                name="end-date"
                value={endTs}
                onChange={(e) => changeToDate(e)}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <Button
                onClick={searchData}
                style={{ marginTop: "5%" }}
                disabled={searchLoading}
              >
                Search{" "}
                {searchLoading && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                {searchLoading && <span></span>}
                {!searchLoading && <span></span>}
              </Button>
              </div>
            <div className="col-md-6">
              <div style={{ marginTop: "5%",marginRight: 133}}>
                {showDownload && (
                  <>
                    <CsvDownload
                      className="btn btn-primary  add-group-btn"
                      {...csvReport}
                      disabled={convertCsv}
                    >
                      {/* Export to CSV{" "} */}
                      {convertCsv && (
                        <i
                          className="fa fa-refresh fa-spin"
                          style={{ marginRight: "5px"}}
                        />
                      )}
                      {convertCsv && <span> Exporting to CSV...</span>}
                      {!convertCsv && <span>Download Full Data</span>}
                    </CsvDownload>
                  </>
                )}
              </div>
            </div>
            </div>
          
        </Modal.Body>
      </Modal>

      {/* 
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> {deviceData.deviceName} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="mx-auto" show={show} onHide={handleClose}>
            <Form.Group controlId="AccessToken">
              <Form.Label> Device Name </Form.Label>
              <Form.Control
                type="text"
                //value={deviceData.accessToken}
                placeholder={deviceData.deviceName}
                onChange={(e) => setDeviceName(e.target.value)}
                required
              ></Form.Control>
            </Form.Group>
          </Form>

          <div className="my-2 d-flex justify-content-between align-items-center mx-auto">
            <div className=" mx-auto">
              <Button
                type="submit"
                className="btn btn-block btn-primary btn-sm font-weight-medium auth-form-btn"
                onClick={() => {
                  changeNameHandler(
                    deviceName,
                    deviceData.deviceId,
                    deviceData._id,
                    deviceData.deviceLabel,
                    deviceData.deviceOwnerId,
                    deviceData.tenantId,
                    deviceData.deviceProfileId
                  );
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light btn-sm" onClick={handleCloseModal}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal> */}
      {/* <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Assign Customer</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="mx-auto" show={show} onHide={handleCloseModal}>
            <Form.Group controlId="AccessToken">
              <Form.Label>Customers </Form.Label>
              <Select
                options={dap_customers.map((dap_customer) => ({
                  id: dap_customer.id,
                  value: dap_customer.id,
                  label: dap_customer.name,
                }))}
                onChange={(e) => submitHandler(e)}
                // defaultValue={dap_deviceList[0].name}
                defaultValue="hi there"
                placeholder={"Set Customer"}
              />
            </Form.Group>
          </Form>
          <div className="my-2 d-flex justify-content-between align-items-center mx-auto">
            <div className=" mx-auto">
              <Button
                type="submit"
                className="btn btn-block btn-primary btn-sm font-weight-medium auth-form-btn"
                onClick={() => {
                  submitHandler(
                    dap_customer.id,

                    device,

                    dap_customer.name
                  );
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary" onClick={handleCloseModal}>
            Save Changes
          </Button> 
        </Modal.Footer>
      </Modal> */}
    </>
  );
};

export default ListPartnerDevices;
